import { RootState } from 'editor/src/store/index';

const getDefaultPersonalizationLockState = (state: RootState) => state.hostSettings.defaultPersonalizationLock;

export default getDefaultPersonalizationLockState;
